/**
 * 未分類パターンセクション
 */

import {
  Paper,
  Alert,
  Stack,
  Text,
  Group,
  Card,
  Badge,
  Tooltip,
  ActionIcon,
} from "@mantine/core";
import { AlertCircle, Link2 } from "lucide-react";
import { PartnerPattern } from "../../services/partnerService";

interface UnmappedPatternsSectionProps {
  patterns: PartnerPattern[];
  onMapPattern: (pattern: PartnerPattern) => void;
}

/**
 * 未分類パターンセクション
 */
export function UnmappedPatternsSection({
  patterns,
  onMapPattern,
}: UnmappedPatternsSectionProps) {
  if (patterns.length === 0) {
    return null;
  }

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Alert
        icon={<AlertCircle size={16} />}
        title={`未分類パターン (${patterns.length}件)`}
        color="yellow"
        mb="md"
      >
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <Text size="sm" style={{ flex: 1 }}>
            以下のパターンは取引先に紐付いていません。鎖アイコンから適切な取引先に紐付けてください。
          </Text>
        </Group>
      </Alert>

      <Stack gap="xs">
        {patterns.map((pattern) => (
          <Card key={pattern.id} withBorder p="sm">
            <Group justify="space-between">
              <Group>
                <Text>&quot;{pattern.pattern}&quot;</Text>
                <Badge variant="light">{pattern.occurrences}回</Badge>
              </Group>
              <Tooltip label="取引先に紐付け">
                <ActionIcon
                  variant="light"
                  color="blue"
                  onClick={() => onMapPattern(pattern)}
                >
                  <Link2 size={16} />
                </ActionIcon>
              </Tooltip>
            </Group>
          </Card>
        ))}
      </Stack>
    </Paper>
  );
}
